<div class="minhas__experiencias">
  <div class="experiencias">
    <div
      class="experiencias__header"
      *ngIf="!carregandoExperiencias && experiencias.length > 0"
    >
      {{
        experiencias.length > 1
          ? experiencias.length + " resgates"
          : experiencias.length + " resgate"
      }}
    </div>

    <div class="sem__minhas__experiencias" *ngIf="exibeDivSemResgate">
      <div class="experiencias__icone">
        <img
          class="opcao__icone"
          src="assets/images/icons/sem_resgate.png"
          alt=""
        />
      </div>
      <div class="experiencias__titulo">
        <p class="lovers-font--bold">Você ainda não fez resgates :(</p>
      </div>
      <div class="experiencias__descricao">
        <p>
          Parece que você ainda não resgatou sua primeira experiência... Use os
          seus cacaus!
        </p>
      </div>
    </div>

    <div
      class="experiencias__listagem"
      *ngIf="!carregandoExperiencias && experiencias.length > 0"
    >
      <div
        class="experiencia__card"
        *ngFor="let experiencia of experiencias; let i = index"
      >
        <app-card-experiencia-resgatada
          *ngIf="
            experiencia.idPromocaoUsuario == 0 ||
            experiencia.idPromocaoUsuario == null
          "
          [imagemSrc]="experiencia.imagemSrc"
          [nome]="experiencia.nome"
          [cacaus]="experiencia.cacaus"
          [unidades]="experiencia.unidadesResgatadas"
          [dataResgate]="experiencia.dataResgate"
          [dataValidade]="experiencia.dataValidade"
          [existePromocoesUsuarios]="experiencia.existePromocoesUsuarios"
          [ehEstornada]="experiencia.idStatus == 3"
          [quantidadeDisponivel]="experiencia.quantidadeDisponivel"
          (onClickAbrirMapa)="abrirMapaExperiencia(i)"
          [mensagemValidade]="experiencia.mensagemValidade"
          [tipo]="experiencia.tipo"
          [idExperienciaMembro]="experiencia.idExperienciaMembro"
          [idsExperienciaMembro]="experiencia.idsExperienciaMembro"
          [cupons]="experiencia.cupons"
          [parceiroNome]="experiencia.parceiro.nome"
          [mecanicaResgate]="experiencia.mecanicaResgate"
          [experienciaTexto]="experiencia.experienciaTexto"
          [experiencia]="experiencia"
          [parceiroViva]="experiencia.parceiroViva"
          [acompanhantes]="experiencia.acompanhantes"
          [dataEvento]="experiencia.dataEvento"
        >
        </app-card-experiencia-resgatada>

        <app-card-experiencia-promocoes
          *ngIf="experiencia.idPromocaoUsuario > 0"
          [idPromocaoUsuario]="experiencia.idPromocaoUsuario"
          [nomePromocao]="experiencia.nomePromocao"
          [dataResgatePromocao]="experiencia.dataResgatePromocao"
          [dataValidadeResgatePromocao]="
            experiencia.dataValidadeResgatePromocao
          "
        >
        </app-card-experiencia-promocoes>
      </div>
    </div>

    <div
      class="experiencias__listagem listagem__loader loader--desktop"
      *ngIf="carregandoExperiencias"
    >
      <ngx-skeleton-loader
        count="2"
        [theme]="{
          'border-radius': '1.5rem',
          width: '100%',
          height: '231px',
          display: 'block',
          margin: 'auto',
          'margin-bottom': '24px'
        }"
      ></ngx-skeleton-loader>
    </div>

    <div
      class="experiencias__listagem listagem__loader loader--mobile"
      *ngIf="carregandoExperiencias"
    >
      <ngx-skeleton-loader
        *ngFor="let i of [1, 2, 3]"
        [theme]="{
          'border-radius': '10px',
          width: '100%',
          height: '420px',
          display: 'block',
          margin: 'auto'
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
</div>

<app-localizacao
  *ngIf="experienciaSelecionada !== undefined"
  [exibirModal]="mapaAberto"
  (fecharCardLocalizacao)="fecharMapaExperiencia()"
  [imagemParceiro]="experienciaSelecionada.parceiro.imagemSrc"
  [idExperiencia]="experienciaSelecionada.id"
>
</app-localizacao>
